// extracted by mini-css-extract-plugin
module.exports = {"navItems":"Navigation_navItems__2nkdZ"};